var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPastelist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1475_23285)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#A67FFB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1475_23285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9963 14.9971C32.9956 14.9909 32.9942 14.9849 32.9935 14.9787C32.9912 14.9605 32.9889 14.9425 32.9852 14.9246C32.9833 14.9154 32.9806 14.9066 32.9785 14.8975C32.9749 14.8829 32.9717 14.8682 32.9673 14.8539C32.9648 14.8458 32.9615 14.8381 32.9588 14.8301C32.9535 14.815 32.9484 14.8 32.9423 14.7852C32.9405 14.7808 32.9383 14.7768 32.9363 14.7724C32.8997 14.6898 32.8485 14.6134 32.7834 14.5482L27.6507 9.41543C27.5119 9.27665 27.3238 9.19873 27.1275 9.19873H16.6347C16.226 9.19873 15.8949 9.52994 15.8949 9.93848V21.8598H13.7398C13.3312 21.8598 13 22.191 13 22.5995V25.4943C13 27.3176 14.3592 28.8008 16.0299 28.8008H29.9703C31.6409 28.8008 33 27.3175 33 25.4943V15.0714C33 15.0464 32.9986 15.0217 32.9963 14.9971ZM27.8673 11.7245L30.4751 14.3324H27.8673V11.7245ZM14.4795 25.4943V23.3393H26.9405V25.4943C26.9405 26.1694 27.1272 26.7976 27.4466 27.3213H16.0299C15.1751 27.3214 14.4795 26.5018 14.4795 25.4943ZM29.9703 27.3214C29.1155 27.3214 28.42 26.5018 28.42 25.4944V22.5995C28.42 22.191 28.0889 21.8598 27.6803 21.8598H17.3744V10.6783H26.3879V15.0722C26.3879 15.4807 26.719 15.8119 27.1276 15.8119H31.5205V25.4944C31.5205 26.5018 30.825 27.3214 29.9703 27.3214Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1475_23285",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1475_23285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1475_23285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1475_23285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastelist);
export default __webpack_public_path__ + "static/media/pastelist.a58bd6d7307c71cb4544a49bb1295432.svg";
export { ForwardRef as ReactComponent };